import { Link } from '@inertiajs/react'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-white py-4 mt-8 border-t border-gray-100">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
          <span>&copy;{currentYear} Simple Casual, LLC.</span>
          <span>&bull;</span>
          <Link href="/terms" className="hover:text-gray-700 transition-colors">
            Terms
          </Link>
          <span>&bull;</span>
          <Link href="/privacy" className="hover:text-gray-700 transition-colors">
            Privacy
          </Link>
        </div>
      </div>
    </footer>
  )
}
